import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../base/constants';
import ExercisesContainer from '../components/exercises/ExercisesContainer';
import { SessionSelectors } from '../session';
import { IState } from '../store/state';
import SessionExercise from './SessionExercise';
import SessionExplanationHint from './SessionExplanationHint';
import './SessionOverview.scss';

export interface ISessionOverviewProps {
  // current session domain id
  domain: number;
  // workout ids for current session
  workouts: number[];
  // disabled workouts which must be hidden
  disabled: boolean[];
}

export const SessionOverviewFC: React.FC<ISessionOverviewProps> = ({ domain, workouts, disabled }) => {
  const { t } = useTranslation();
  const loading = domain === 0 || workouts.length === 0;
  const skeletonClass = loading ? SKELETON_CLASSNAME : '';
  let title = SKELETON_DUMMYTEXT;
  let sessionWorkouts = [0, 0, 0, 0];
  if (!loading) {
    const domainTitle = `$t(common:Domain.Title.${domain})`;
    title = t('Dashboard.SessionTitle', { domain: domainTitle });
    sessionWorkouts = workouts;
  }
  return (
    <div className="session-overview">
      <ExercisesContainer skeletonClass={skeletonClass} title={title} hint={<SessionExplanationHint />}>
        {sessionWorkouts.map((workout, index) => {
          return disabled[index] ? null : (
            <SessionExercise key={`${workout}-${index}`} index={index} workoutId={workout} />
          );
        })}
      </ExercisesContainer>
    </div>
  );
};

export const mapStateToProps = (state: IState) => {
  return {
    domain: SessionSelectors.getSessionDomain(state),
    workouts: SessionSelectors.getSessionWorkouts(state),
    disabled: SessionSelectors.getDisabledState(state),
  } as ISessionOverviewProps;
};

const SessionOverview = connect(mapStateToProps)(SessionOverviewFC);
export default SessionOverview;
